<template>
    <entity-editor entity="rumour" :id="id" :new-entity="newRumour" @isDirtyChange="handleIsDirtyChange">
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12" md="6">
                    <v-select
                        :items="rumourEvents"
                        v-model="doc.eventId"
                        label="Event"
                        item-text="name"
                        item-value="id"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select
                        :items="rumourTypes"
                        v-model="doc.rumourType"
                        label="Rumour Type"
                        :rules="[requiredRule]"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.name" label="Name" :rules="[requiredRule]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <large-text-editor
                        v-model="doc.description"
                        label="Details"
                        :rules="[requiredRule]"
                    ></large-text-editor>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
import { mapGetters } from 'vuex'
import editorMixin from '../../mixins/editorMixin'
export default {
    name: 'RumourEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            rumourTypes: [
                { text: 'Guildsman', value: 1 },
                { text: 'Merchant', value: 2 },
                { text: 'Rumour Monger', value: 3 },
                { text: 'Storyteller', value: 4 },
                { text: 'Wanderer', value: 5 },
                { text: 'War Scout', value: 6 },
            ],
        }
    },
    computed: {
        ...mapGetters(['events', 'nextEvent', 'currentEvent']),
        rumourEvents() {
            return this.events.filter(x => x.isRumourEvent)
        },
    },
    methods: {
        newRumour() {
            return {
                name: '',
                description: '',
                rumourTypeId: 0,
                eventId: this.currentEvent || this.nextEvent,
                teamId: null,
            }
        },
    },
}
</script>
